import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactGA from 'react-ga';
import { IntlProvider } from 'react-intl';
import fa from './i18n/compiled-lang/fa.json';

import storeContainer from 'Config/redux/store';
import PageProvider from 'Components/HOC/PageProvider';
import { isoLangCodes } from 'Constants';
import { initGTM } from 'Helpers';
import 'webrtc-adapter';

import '@takhfifan/saaghi/lib/theme/theme.scss';
import 'Assets/styles/custom.scss';

const { store, persistor } = storeContainer;

const CURRENT_APP_VERSION = '1.2.01';

const App = () => {
	useEffect(() => {
		const storedVersion = localStorage.getItem('app_version');
		if (storedVersion !== CURRENT_APP_VERSION) {
			const clearAndReload = async () => {
				try {
					localStorage.setItem('app_version', CURRENT_APP_VERSION);

					if (
						'serviceWorker' in navigator &&
						navigator.serviceWorker.controller
					) {
						navigator.serviceWorker.controller.postMessage({
							type: 'CLEAR_CACHES',
						});
					}

					if (typeof caches !== 'undefined') {
						const names = await caches.keys();
						await Promise.all(names.map((name) => caches.delete(name)));
					}

					Object.keys(sessionStorage).forEach((key) => {
						if (key !== 'redirect') {
							sessionStorage.removeItem(key);
						}
					});

					Object.keys(localStorage).forEach((key) => {
						if (
							key !== 'app_version' &&
							key !== 'panel_auth' &&
							key !== 'user' &&
							!key.startsWith('price_list_images_')
						) {
							localStorage.removeItem(key);
						}
					});

					setTimeout(() => {
						window.location.reload();
					}, 300);
				} catch (err) {
					console.error('Error clearing caches:', err);
				}
			};

			clearAndReload();
		} else {
			initiateGA();
			initiateGTM();
		}
	}, []);

	const initiateGA = () => {
		if (!process.env.GA_ID) {
			return;
		}
		ReactGA.initialize(process.env.GA_ID, { gaOptions: { name: 'pwa' } });
	};

	const initiateGTM = () => {
		initGTM();
	};

	return (
		<Provider store={store}>
			<IntlProvider
				locale={isoLangCodes.fa}
				messages={fa}
			>
				<PersistGate
					loading={null}
					persistor={persistor}
				>
					<Router basename='/pwa'>
						<PageProvider />
					</Router>
				</PersistGate>
			</IntlProvider>
		</Provider>
	);
};
export default App;
